<template>
  <div>
    <div v-if="show">
      <div class="text-center pt-1">
        <span class="title">{{ title }}</span>
        <br>
        <span
          v-if="description"
          class="description">{{ description }}
          <br>
        </span>
        <span class="big-number">{{ value }}</span>
      </div>
    </div>
    <div v-else>
      <div class="col-md-10 text-center">
        <div class="big-number-wrapper">
          <b-form-input
            v-model="title"
            class="big-number-input big-number-title"
            type="text"
            name="title"
            placeholder="Click to add title" />
          <b-form-input
            v-model="description"
            class="big-number-input big-number-description"
            type="text"
            placeholder="Click to add description" />
          <span class="big-number">{{ value }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "BigNumber",
    props: ['chartData', 'show'],
    data() {
      return {
        'title': this.chartData.title,
        'description': this.chartData.description,
        'field': this.chartData.field,
        'value': '',
      }
    },
    methods: {
      graph() {
        this.title = this.chartData.title;
        this.description = this.chartData.description;
        this.field = this.chartData.field;
        this.value = this.chartData.data[0][this.field];
      },
    }
  }
</script>

<style scoped>
    .title {
        font-size: 18px;
    }
    .description {
        font-size: 16px;
    }
    .big-number-wrapper {
        text-align: center;
        margin: auto;
        width: 368px;
        display: inline-block;
        border: 1px solid #F1F2F5
    }
    .big-number {
        font-size: 40px;
    }
    .big-number-input {
        border: 0;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        padding-left: 20px;
        margin-right: 20px;
    }
    .big-number-title {
        font-size: 18px;
        color: #393945;
    }
    .big-number-description {
        font-size: 16px;
        color: #53535C;
    }
    .form-control:focus {
        -webkit-box-shadow: none;
        box-shadow: none;
    }
</style>